import { findFieldConfig } from '../../conditionPropertyKeys';
import {
  type TypedFormFieldConfiguration,
  useCustomisableFormDataContext,
} from '../../customisable-form-data/CustomisableFormDataContext';
import { useRiskSmartForm } from '../RiskSmartFormContext';

type FieldConfig = Pick<
  TypedFormFieldConfiguration,
  'FieldId' | 'Hidden' | 'Label' | 'ReadOnly' | 'Required'
> &
  Partial<
    Pick<
      TypedFormFieldConfiguration,
      | 'Conditions'
      | 'DefaultValue'
      | 'Description'
      | 'FormConfigurationParentType'
    >
  >;

const DEFAULT_FIELD_CONFIG: FieldConfig = {
  Required: false,
  ReadOnly: false,
  Hidden: false,
  FieldId: '',
  Label: '',
};

type UseFieldConfigOptions = {
  defaultRequired?: boolean;
};

/**
 * Returns the field configuration for a given field ID.
 * Note, this does NOT currently return custom attribute labels or options.
 * @param fieldId
 * @param options
 * @returns
 */
export const useFieldConfig = (
  fieldId?: string,
  options?: UseFieldConfigOptions
): FieldConfig | null => {
  const { parentType } = useRiskSmartForm();

  const { formFieldConfigurations } = useCustomisableFormDataContext();

  if (!parentType) {
    return null;
  }

  const fieldOptionsData = findFieldConfig(formFieldConfigurations, fieldId);

  return (
    fieldOptionsData ?? {
      ...DEFAULT_FIELD_CONFIG,
      FormConfigurationParentType: parentType,
      Required: options?.defaultRequired ?? false,
    }
  );
};
